import gsap from "gsap"
import { module as BaseModule } from "modujs"
import Swiper from "swiper"
import { Keyboard, Navigation } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"

export default class extends BaseModule {
  init() {
    const slider = this.el.querySelector(".swiper")
    const { sliderConfig } = slider.dataset

    const params = {
      project: {
        modules: [Navigation, Keyboard],
        slidesPerView: 1,
        speed: 300,
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 20,
          },
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          prevEl: this.el.querySelector("[data-slider-prev]"),
          nextEl: this.el.querySelector("[data-slider-next]"),
        },
        loop: true,
      },
    }

    this.swiper = new Swiper(slider, params[sliderConfig])
    gsap.to(slider, {
      opacity: 1,
      duration: 2,
      ease: "power2.Out",
    })

    // Fullscreen functionality
    // Buttons are siblings to the slider module, so search in document
    this.enlargeButton = document.querySelector("[data-slider-enlarge]")
    this.closeButton = document.querySelector("[data-slider-close]")
    this.isFullscreen = false

    // Bind methods for proper cleanup
    this.handleEnlarge = this.enterFullscreen.bind(this)
    this.handleClose = this.exitFullscreen.bind(this)
    this.handleEscape = (e) => {
      if (e.key === "Escape" && this.isFullscreen) {
        this.exitFullscreen()
      }
    }

    if (this.enlargeButton) {
      this.enlargeButton.addEventListener("click", this.handleEnlarge)
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleClose)
    }

    // Close on Escape key
    window.addEventListener("keydown", this.handleEscape)

    if (window.innerWidth >= 1024) {
      this.follower = document.querySelector('[data-follower]')
      this.followerAreas = Array.from(document.querySelectorAll('[data-follower-area]'))
      if (!this.follower || this.followerAreas.length === 0) return

      this.hasMovedFollower = false
      this.moveFollower = (e) => {
        gsap.to(this.follower, {
          x: e.clientX,
          y: e.clientY,
          duration: this.hasMovedFollower ? 0.3 : 0,
          ease: "power2.out",
          overwrite: true,
        })
        this.hasMovedFollower = true
        const next = this.follower.querySelector('[data-follower-next]')
        const prev = this.follower.querySelector('[data-follower-prev]')
        if (e.clientX > window.innerWidth / 2) {
          if (next) next.style.opacity = 1
          if (prev) prev.style.opacity = 0
        } else {
          if (next) next.style.opacity = 0
          if (prev) prev.style.opacity = 1
        }
      }

      this.showFollower = () => {
        this.follower.style.display = 'block'
        this.hasMovedFollower = false
      }
      this.hideFollower = () => { this.follower.style.display = 'none' }
      this.follower.style.display = 'none'

      window.addEventListener('mousemove', this.moveFollower)
      this.followerAreas.forEach(area => {
        area.addEventListener('mouseenter', this.showFollower)
        area.addEventListener('mouseleave', this.hideFollower)
      })
    }
  }

  enterFullscreen() {
    if (this.isFullscreen) return
    this.isFullscreen = true
    this.el.classList.add("slider-fullscreen")
    document.body.classList.add("slider-fullscreen-active")
    
    if (this.enlargeButton) {
      this.enlargeButton.style.display = "none"
    }
    if (this.closeButton) {
      this.closeButton.style.display = "block"
    }
  }

  exitFullscreen() {
    if (!this.isFullscreen) return
    this.isFullscreen = false
    this.el.classList.remove("slider-fullscreen")
    document.body.classList.remove("slider-fullscreen-active")
    
    if (this.enlargeButton) {
      this.enlargeButton.style.display = "block"
    }
    if (this.closeButton) {
      this.closeButton.style.display = "none"
    }
  }

  destroy() {
    if (this.isFullscreen) {
      this.exitFullscreen()
    }
    
    window.removeEventListener("keydown", this.handleEscape)
    
    if (this.enlargeButton && this.handleEnlarge) {
      this.enlargeButton.removeEventListener("click", this.handleEnlarge)
    }
    
    if (this.closeButton && this.handleClose) {
      this.closeButton.removeEventListener("click", this.handleClose)
    }

    if (window.innerWidth >= 1024 && this.follower) {
      window.removeEventListener('mousemove', this.moveFollower)
      gsap.killTweensOf(this.follower)
      if (this.followerAreas) {
        this.followerAreas.forEach(area => {
          area.removeEventListener('mouseenter', this.showFollower)
          area.removeEventListener('mouseleave', this.hideFollower)
        })
      }
    }
  }
}
